<template>
  <v-container>
    <h2>ESIS -ийг xүлээж байна</h2>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
